import { render } from "./comingSoon.vue?vue&type=template&id=c4f91c4a&scoped=true"
import script from "./comingSoon.vue?vue&type=script&lang=js"
export * from "./comingSoon.vue?vue&type=script&lang=js"

import "./comingSoon.vue?vue&type=style&index=0&id=c4f91c4a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4f91c4a"]])

export default __exports__